import { render, staticRenderFns } from "./OmniSearch.vue?vue&type=template&id=3a396b6b&"
import script from "./OmniSearch.vue?vue&type=script&lang=js&"
export * from "./OmniSearch.vue?vue&type=script&lang=js&"
import style0 from "./OmniSearch.vue?vue&type=style&index=0&id=3a396b6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports